import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 js-main-content" }
const _hoisted_2 = { class: "_flexwrap _my-6" }
const _hoisted_3 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_4 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_5 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_6 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_7 = { class: "_flexwrap _ai-c" }
const _hoisted_8 = { class: "gfu-1of1 gfu-3of4--m _pa-3 _tac _tal--l" }
const _hoisted_9 = { class: "gfu-hd gfu-hd--h3" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "gfu-1of1 gfu-1of4--m _tac _pa-3" }
const _hoisted_12 = { class: "gfu-hd gfu-hd--h2 _tc--accent" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "_tac" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_base_hero = _resolveComponent("base-hero")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_button = _resolveComponent("base-button")
  const _component_box = _resolveComponent("box")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, null, {
    default: _withCtx(() => [
      _createVNode(_component_footer_navigation, {
        "current-page": _ctx.Resources.Layout.FeesLink
      }, null, 8 /* PROPS */, ["current-page"]),
      _createVNode(_component_base_hero, {
        title: "Fees",
        description: "Easily fund and manage your campaign. Exclusive features at no extra cost.",
        type: "fees"
      }),
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_box, {
          class: "_tac _mb-6",
          main: true,
          huge: true
        }, {
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, [
              _createTextVNode("Exclusive benefits "),
              _createElementVNode("span", { class: "_fw-n" }, "for your project.")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_tooltip, { text: "Lots of tools to help you succeed." }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "gears",
                      size: "2x",
                      class: "_tc--accent"
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, "Advanced features", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_tooltip, { text: "Various payment methods, free installments, and many more." }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "shopping-cart",
                      size: "2x",
                      class: "_tc--accent"
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, "Great checkout", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_tooltip, { text: "Reach millions of backers!" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "users",
                      size: "2x",
                      class: "_tc--accent"
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, "Huge community", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_tooltip, { text: "Our team shares their expert knowledge for free." }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "messages-question",
                      size: "2x",
                      class: "_tc--accent"
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, "Premium support", -1 /* CACHED */))
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _createVNode(_component_base_button, {
              tag: "a",
              href: $options.becomeACreatorUrl
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Learn more", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["href"])
          ]),
          _: 1 /* STABLE */
        }),
        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, "Our offer", -1 /* CACHED */)),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, "Complex crowdfunding and pledge manager services depending on your needs. No hidden fees.", -1 /* CACHED */)),
        _createVNode(_component_box, {
          class: "_my-6",
          main: true,
          huge: true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.title
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "gfu-hr gfu-hr--light" }, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (item.badge)
                      ? (_openBlock(), _createBlock(_component_base_badge, {
                          key: 0,
                          theme: item.badge.theme
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.badge.text), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme"]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("h4", _hoisted_9, _toDisplayString(item.title), 1 /* TEXT */),
                    _createElementVNode("div", {
                      class: "gfu-bt gfu-bt--b1",
                      innerHTML: item.description
                    }, null, 8 /* PROPS */, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(item.value), 1 /* TEXT */),
                    (item.valueDescription)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.valueDescription), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "gfu-hr gfu-hr--light _mb-6" }, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_base_button, {
                tag: "a",
                href: $options.launchYourProjectUrl
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Launch your project", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["href"])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}